import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { colors } from 'shared/styles/colors'
import dimensions from 'shared/styles/dimensions'
import styled from 'styled-components'

export const StyledAutocomplete = styled(Autocomplete)`
  .MuiInputBase-root.MuiAutocomplete-inputRoot {
    height: ${dimensions.componentHeight.large}px;
  }
  .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] {
    padding: 0;
  }
`
export const StyledTextField = styled(TextField)``

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
`

export const HelperMessage = styled.span`
  font-family: 'Roboto';
  font-style: italic;
  font-size: 14px;
  font-weight: normal;
  margin-left: 5px;
  color: ${colors.red};
`
